import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import paths from 'routes/paths';

const ForgetPasswordForm = () =>
{
  // State
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  // Handler
  const handleSubmit = e =>
  {
    e.preventDefault();
    if (email)
    {
      navigate(`${paths.confirmMail}?email=${encodeURIComponent(email)}`);
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Email address'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email}>
          Send reset link
        </Button>
      </Form.Group>
    </Form>
  );
};

export default ForgetPasswordForm;
